import { render } from "./BookingTable.vue?vue&type=template&id=5e1f54ba"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__